
import { Component, Vue } from "vue-property-decorator";
import { isOptimaHotelUrl, isVisibleAlignmentAlert } from "@/lib/functions";
import store from "@/store";

@Component
export default class ModalGardenhotels extends Vue {
  private visible: boolean = false;
  private href: string = "";
  private gasendsite: string = "";

  private handleClick(e: MouseEvent) {
    if (store.getters["auth/lang"] !== "ja") {
      return;
    }

    const target = e.target;
    if (
      !(target instanceof HTMLElement) ||
      target.closest("#go-gardenhotels-modal") ||
      target.tagName !== "A"
    ) {
      return;
    }

    const href = target.getAttribute("href");
    if (href === null || !isOptimaHotelUrl(href)) {
      return;
    }

    e.preventDefault();

    if (store.getters["auth/mghrwc"]) {
      window.location.href = `/to-mghrwc?redirect=${encodeURIComponent(href)}`;
      return;
    }

    this.href = href;
    this.gasendsite = (target as HTMLElement).dataset.gasendsite || "";
    this.visible = true;
  }

  get visibleAlertAlignment(): boolean {
    return isVisibleAlignmentAlert(store.getters["auth/group"]);
  }

  close() {
    this.visible = false;
  }

  mounted() {
    document.addEventListener("click", this.handleClick);
  }

  beforeDestroy() {
    document.removeEventListener("click", this.handleClick);
  }
}
